import { QuoteWorkspaceProvider } from 'contexts/quote-workspace.context';
import { FC } from 'react';
import { WorkspaceAnalyticCategoryContext } from 'shared/middlewares/analytics/loggerContext';

import { DynamicQuotesWorkspace } from './DynamicQuotesWorkspace';

export const DynamicWorkspaceWrapper: FC = () => {
  return (
    <WorkspaceAnalyticCategoryContext.Provider value="Primary market dynamic">
      <QuoteWorkspaceProvider value="dynamic">
        <DynamicQuotesWorkspace />
      </QuoteWorkspaceProvider>
    </WorkspaceAnalyticCategoryContext.Provider>
  );
};
